import { generateClient } from "aws-amplify/api";

const client = generateClient();

export async function requestListNotification(dispatch, payload) {
  try {
    const {
      page,
      owner,
      limit = 25,
      createdAt = "",
      sortDirection = "DESC",
      nextToken = "start",
    } = payload;

    dispatch({ type: "REQUEST_LIST_NOTIFICATION", payload: { page } });

    const params = {
      owner,
      limit,
      sortDirection,
    };

    if (createdAt) params.createdAt = createdAt;

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token && items.length === 0) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: notificationsByOwnerCreatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_NOTIFICATION",
        payload: { request },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.notificationsByOwnerCreatedAt.items];
      token = res.data.notificationsByOwnerCreatedAt.nextToken;
    }

    dispatch({
      type: "LIST_NOTIFICATION_SUCCESS",
      payload: { items, nextToken: token, nextPage: page + 1 },
    });
  } catch (error) {
    dispatch({ type: "LIST_NOTIFICATION_ERROR", error });
  }
}

export async function requestUpdateNotification(dispatch, payload) {
  try {
    const { id, isRead = true } = payload;

    dispatch({ type: "REQUEST_UPDATE_NOTIFICATION" });

    const params = {
      id,
      isRead,
    };

    const res = await client.graphql({
      query: updateNotification,
      variables: {
        input: params,
      },
    });

    const notification = res.data.updateNotification;

    dispatch({
      type: "UPDATE_NOTIFICATION_SUCCESS",
      payload: { notification },
    });
  } catch (error) {
    dispatch({ type: "UPDATE_NOTIFICATION_ERROR", error });
  }
}

export function addLocalNotification(dispatch, payload) {
  dispatch({ type: "ADD_LOCAL_NOTIFICATION", payload });
  setTimeout(() => {
    dispatch({ type: "REMOVE_LOCAL_NOTIFICATION", payload });
  }, 8000);
}

export function removeLocalNotification(dispatch, payload) {
  dispatch({ type: "REMOVE_LOCAL_NOTIFICATION", payload });
}

const notificationsByOwnerCreatedAt = /* GraphQL */ `
  query NotificationsByOwnerCreatedAt(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByOwnerCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        category
        type
        typeId
        isRead
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const updateNotification = /* GraphQL */ `
  mutation UpdateNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      id
      title
      description
      category
      type
      typeId
      isRead
      createdAt
      updatedAt
    }
  }
`;
